import { IconSizesTypes, IconComponent } from '@/components/icon/types.ts';
import * as defaultIcons from '@/components/icon/iconPackages/default/index.ts';
import * as multicolorIcons from '@/components/icon/iconPackages/multicolor/index.ts';
import * as size32Icons from '@/components/icon/iconPackages/size-32/index.ts';

export const iconSizes: IconSizesTypes[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'];

// Map of icon packages, typed properly
export const iconPackages: Record<string, Record<string, IconComponent>> = {
	default: defaultIcons as Record<string, IconComponent>,
	multicolor: multicolorIcons as Record<string, IconComponent>,
	size32: size32Icons as Record<string, IconComponent>,
};
